{
  "App": "Aplicación",
  "Profile": "Perfil",
  "My Account": "Mi cuenta",
  "Contacts": "Contactos",
  "Preferences": "Preferencias",
  "Family Language": "Idioma de la familia",
  "Program Consent": "Consentimiento para el programa",
  "Yes": "Sí",
  "No": "No",
  "Not submitted": "Sin enviar",
  "See anything missing? Contact your Caring Adult": "¿Falta algo? Ponte en contacto con tu adulto protector.",
  "Messages": "Mensajes",
  "Caring Adult for": "Adulto protector de",
  "Former Caring Adult for": "Adulto protector anterior de",
  "Write your message here...": "Escribe tu mensaje aquí...",
  "I need help with": "Necesito ayuda con",
  "Academic": "Asuntos académicos",
  "After School/ Out of School": "Asuntos extraescolares",
  "Applying for benefits": "Solicitud de beneficios",
  "Childcare": "Cuidado infantil",
  "Employment / Adult Education": "Empleo/educación para adultos",
  "Food": "Alimentación",
  "Housing": "Vivienda",
  "Legal services": "Servicios legales",
  "Material Resources / Clothing / Laundry": "Recursos materiales/indumentaria/lavandería",
  "Mental/emotional health": "Salud mental/emocional",
  "Physical health/asthma": "Salud física/asma",
  "Transportation": "Transporte",
  "Send": "Enviar",
  "Today": "Hoy",
  "No messages yet": "No hay mensajes aún",
  "No messages": "No hay mensajes",
  "Start a conversation below": "Inicia una conversación a continuación",
  "This Caring Adult is no longer available": "Este adulto responsable ya no está disponible",
  "No longer available ": "Ya no está disponible ",
  "Monday": "Lunes",
  "Tuesday": "Martes",
  "Wednesday": "Miércoles",
  "Thursday": "Jueves",
  "Friday": "Viernes",
  "Saturday": "Sábado",
  "Sunday": "Domingo",
  "Emergency Contacts": "Contactos de emergencia",
  "Supervisor of Social Workers for the Bronx": "Supervisor de trabajadores sociales para el Bronx",
  "Student Services Manager, High School District": "Director de Servicios Estudiantiles, Distrito de Enseñanza Secundaria",
  "Social Worker, Central Crisis Support Team": "Trabajador social, Equipo Central de Apoyo ante Crisis (Central Crisis Support Team)",
  "Support Line": "Línea de asistencia",
  "Suicide and Crisis Lifeline": "Línea de prevención del suicidio y situaciones de crisis (Suicide and Crisis Lifeline)",
  "Emergencies": "Emergencias",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "Si te enfrentas a una emergencia potencialmente mortal y necesitas ayuda inmediata, llama o envía un mensaje de texto al 911",
  "About New Visions": "Acerca de New Visions",
  "Privacy and Terms": "Privacidad y términos",
  "Homepage": "Página de inicio",
  "Home Page": "Página de inicio",
  "My family": "Mi familia",
  "Available Services": "Servicios disponibles",
  "Grade": "Grado",
  "School": "Escuela",
  "Attendance this year": "Asistencia este año",
  "Absences last 5 days": "Ausencias en los últimos 5 días",
  "Caring Adult": "Adulto protector",
  "Message": "Mensaje",
  "Not available": "No disponible",
  "Not yet assigned": "Sin asignar aún",
  "No absences": "Sin ausencias",
  "Phone not available": "Teléfono no disponible",
  "Email address not available": "Dirección de correo electrónico no disponible",
  "January": "Enero",
  "February": "Febrero",
  "March": "Marzo",
  "April": "Abril",
  "May": "Mayo",
  "June": "Junio",
  "July": "Julio",
  "August": "Agosto",
  "September": "Septiembre",
  "October": "Octubre",
  "November": "Noviembre",
  "December": "Diciembre",
  "Sidenav": "Navegación lateral",
  "Home": "Inicio",
  "Log out": "Cerrar sesión",
  "Accessibility": "Accesibilidad",
  "Skip to main content": "Ir al contenido principal",
  "Email": "Correo electrónico",
  "Phone": "Teléfono",
  "Family Portal": "Portal para la familia",
  "Every Child and Family is Known": "Reconocer a Cada Niño y Familia",
  "Family Portal: Every Child and Family is Known": "Portal para la familia: Reconocer a Cada Niño y Familia",
  "Close menu": "Cerrar menú",
  "Open menu": "Abrir menú",
  "Notes": "Notas",
  "Send message": "Enviar mensaje",
  "Languages": "Idiomas",
  "Consent status": "Estado del consentimiento",
  "Select": "Seleccionar",
  "Language selector": "Selector de idioma",
  "Sorry": "Lo sentimos",
  "we couldn't find that page": "no pudimos encontrar esa página",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "Aún no está autorizado a iniciar sesión en el Portal Familiar. Comuníquese con su adulto a cargo para obtener acceso."
}
